module.exports = __webpack_public_path__ + "static/media/art8.c0a3acc6.png";